/* eslint-disable */
/* eslint-disable sonarjs/no-redundant-boolean */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useContext, useState, useCallback, useRef, useEffect } from 'react';
//import React, { useContext, useState } from 'react';
import { useAutoRefresh, parseRefreshInterval, parseIdleTimeout, DEFAULT_REFRESH_INTERVAL_MS } from '../../utils/useAutoRefresh';
import { globalStyles } from '../Pricing/Styles/globalstyles';
import { PricingReportStyle } from '../Pricing/Styles/PricingReport';
import { ReactComponent as RacFilter } from '../../assets/images/RacSort.svg';
import { ReactComponent as FilterClose } from '../../assets/images/filter-close-icon.svg';
// import { ReactComponent as Info } from '../../assets/images/info-button.svg';
import { ReactComponent as SortIcon } from '../../assets/images/sort-icon.svg';
import { ReactComponent as SortIconUp } from '../../assets/images/sort-icon-up.svg';
import { ReactComponent as NorecordsIcon } from '../../assets/images/No-records.svg';
import { ReactComponent as SuccesIcon } from '../../assets/images/success-icon.svg';
import { ReactComponent as SomethingWrong } from '../../assets/images/no-records-found.svg';
// import { ContainerContext } from '../../app/App';
// import { CustomPropInterface } from '../../index';
import moment from 'moment';
import { MultiSelect } from 'react-multi-select-component';
import ReactPaginate from 'react-paginate';
import {
  getZoneDD,
  getReportGridData,
  generateReport,
  getXlFile,
  fetchDropDownAPI,
} from '../../api/user';
//import { getUserID,getZoneDD, getReportGridData, generateReport, getXlFile, getReportGrid } from '../../api/user';

//import Tooltip from "@material-ui/core/Tooltip"; // used in Pricing upload
//import Tooltip from '@mui/material/Tooltip';
import { useHistory } from 'react-router';

import {
  RACTableCell,
  RACTable,
  RACTableRow,
  Grid,
  Card,
  CardContent,
  RACButton,
  Typography,
  RACSelect,
  RACDatePicker,
  RACInfoIcon,
  RACModalCard,
  CircularProgress,
} from '@rentacenter/racstrap';
import MissingPrice from '../shared/MissingPriceHazard/MissingPrice';
import { accessFeature, getEmployeeInfoAndReferenceData } from '../shared/getEmployeeInfoAndReferenceData';
import { CustomPropInterface } from '../../index';
import { ContainerContext } from '../../app/App';
import { SYSTEM_GENERATED, USER_GENERATED } from '../../constants/constants';

export interface columns {
  columnId: string;
  sortOrder: string;
  columnTitle: string;
  IsSorted: boolean;
  IsSortable: boolean;
  columnType?: 'link';
  elipse?: boolean;
  handleColumnClick1?: () => void;
  handleColumnClick2?: () => void;
  subColumns?: columns[];
  index?: string;
  isAction?: boolean;
}

export default function PricingReport() {
  //styles
  const classes = globalStyles();
  const pricing = PricingReportStyle();
  //state variables
  //const [companyCode, setcompanyCode] = useState('');
  //const [empid, setempid] = useState('');

  const [loader, setloader] = useState('');
  const [gridbind, setgridbind] = useState(false);
  const [popupop, setpopupop] = useState('');
  const [errormsg, seterrormsg] = useState('');
  const [errormsgTo, seterrormsgTo] = useState('');
  const [errormsgSG, seterrormsgSG] = useState('');
  const [errormsgToSG, seterrormsgToSG] = useState('');
  const [totalRowCountUG, setTotalRowCountUG] = useState(0);
  const [pageNumberUG, setPageNumberUG] = useState(0);
  const [pageCountUG, setPageCountUG] = useState(0);
  const [totalRowCountSG, setTotalRowCountSG] = useState(0);
  const [pageNumberSG, setPageNumberSG] = useState(0);
  const [pageCountSG, setPageCountSG] = useState(0);
  const filterobjectmodel = { status: '', fromDate: '', toDate: '' }
  const [filterobject, setfilterobject] = useState<any>(filterobjectmodel); //filter object
  const [systemFilterobject, setSystemFilterobject] = useState<any>(filterobjectmodel); //filter object
  const [userGenGridData, setUserGenGridData] = useState<any>([]);
  const [systemGenGridData, setSystemGenGridData] = useState<any>([]);
  const [genZone, setgenZone] = useState([]);
  const [genType, setgenType] = useState('');
  const [zonevalue, setzonevalue] = useState([]);
  const [filterAppliedUG, setFilterAppliedUG] = useState(false);
  const [filterAppliedSG, setFilterAppliedSG] = useState(false);
  const history = useHistory();
  const [nocontent, setnocontent] = useState(false);
  //Download Button logic
  const [Downloadloader, setDownloadloader] = useState('-1');
  const [selectAll, setSelectAll] = useState<boolean>(true);
  const [showSecondaryCriteria, setShowSecondaryCriteria] = useState(false)
  const [hasAccess, setHasAccess] = useState({
    costBasedPricingViewAccess: false,
    pricingReportEditAccess: false,
    zoneBasedPricingViewAccess: false,
    autoTermPricingViewAccess: false
  })
  const [activetab, setActivetab] = useState<number>(1)
  const [refreshIntervalMs, setRefreshIntervalMs] = useState<number | null>(null);
  const [idleTimeoutMs, setIdleTimeoutMs] = useState<number>(5 * 60 * 1000);
  //Use Context
  //const containerData = useContext(ContainerContext) as CustomPropInterface;
  const userGenFromDate = filterobject.fromDate && moment(filterobject.fromDate, "YYYY-MM-DD");
  const userGenToDate = filterobject.toDate && moment(filterobject.toDate, "YYYY-MM-DD");
  const sysGenFromDate = systemFilterobject.fromDate && moment(systemFilterobject.fromDate, "YYYY-MM-DD");
  const sysGenToDate = systemFilterobject.toDate && moment(systemFilterobject.toDate, "YYYY-MM-DD");

  const sortDirection = {
    ASC: 'asc',
    DESC: 'desc',
  };

  const headcolumns = [
    {
      columnId: 'zone',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Zone',
      IsSorted: false,
      IsSortable: false,
    },
    {
      columnId: 'type',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Type',
      IsSorted: false,
      IsSortable: true,
    },
    {
      columnId: 'date',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Date & Time',
      IsSorted: true,
      IsSortable: true,
    },
    {
      columnId: 'status',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Status',
      IsSorted: false,
      IsSortable: true,
    },
    {
      columnId: 'action',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Action',
      IsSorted: false,
      IsSortable: false,
    },
  ];
  const sysGenHeadcolumns = [
    {
      columnId: 'type',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Type',
      IsSorted: false,
      IsSortable: true,
    },
    {
      columnId: 'date',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Date & Time',
      IsSorted: true,
      IsSortable: true,
    },
    {
      columnId: 'status',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Status',
      IsSorted: false,
      IsSortable: true,
    },
    {
      columnId: 'action',
      sortOrder: sortDirection.ASC,
      columnTitle: 'Action',
      IsSorted: false,
      IsSortable: false,
    },
  ];
  const [headerdata, setheaderdata] = useState(headcolumns);
  const [sysGenHeaderdata, setSysGenHeaderdata] = useState(sysGenHeadcolumns);
  const monthDateFormat = 'MM/DD/YYYY';
  const yearDateFormat = 'YYYY-MM-DD';
  const timeZoneChicago = 'America/Chicago';
  const fontOpens = 'OpenSans-regular';
  const borRadius = '25px !important';
  const currentDate = moment(moment(new Date()).format("YYYY-MM-DD"), "YYYY-MM-DD");
  const containerData = useContext(ContainerContext) as CustomPropInterface;

  //debugger
  useEffect(() => {
    const Griddata = async () => {
      const responses = await Promise.all([gridloadapi('1', 'UserGenerated'), gridloadapi('1', 'SystemGenerated'), getZoneDD()]);
      if (responses[2].status && responses[2].status == 200) {
        if (responses[2].data.result) {
          setloader('');
          optionsfill(responses[2].data.result);
        } else if (!responses[2].data) {
          setloader('');
          setpopupop('GridError');
        }
      } else {
        setloader('');
        setpopupop('GridError');
      }
    };
    Griddata();
    const showSecondaryCriteria = async () => {
      const response = await getEmployeeInfoAndReferenceData(containerData, {}, true);
      console.log('menu container or api response', response)
      const resp = await accessFeature(response);
      console.log('show secondaryCriteria response', resp)
      setShowSecondaryCriteria(resp)
      setHasAccess({
        ...hasAccess, costBasedPricingViewAccess: accessFeature(response, 'Cost Based Pricing', 'view'),
        zoneBasedPricingViewAccess: accessFeature(response, 'Zone Based Pricing', 'view'),
        pricingReportEditAccess: accessFeature(response, 'Pricing Reports', 'edit'),
        autoTermPricingViewAccess: accessFeature(response, 'Autoterm', 'view')
      })
      try {
        const payload: any = {
          type: ['CONFIG']
        }
        const configResponse = await fetchDropDownAPI(payload);
        if (configResponse?.status === 200) {
          setRefreshIntervalMs(parseRefreshInterval(configResponse.data?.config));
          setIdleTimeoutMs(parseIdleTimeout(configResponse.data?.config));
        } else {
          setRefreshIntervalMs(DEFAULT_REFRESH_INTERVAL_MS);
        }
      } catch {
        setRefreshIntervalMs(DEFAULT_REFRESH_INTERVAL_MS);
      }
    }
    showSecondaryCriteria()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const gridloadapi = async (offset: string = '1', type: string, isClear?: boolean, silent?: boolean) => {
    if (!silent) setloader('masterLoader');

    let request = {}
    if (type == 'UserGenerated') {
      request = {
        reportType: USER_GENERATED,
        status: isClear ? undefined : filterobject.status ? [filterobject.status] : undefined,
        fromDate: isClear ? undefined : (filterobject.fromDate || undefined),
        toDate: isClear ? undefined : (filterobject.toDate || undefined),
        limit: '25',
        offset: offset
      }
    } else if (type == 'SystemGenerated') {
      request = {
        reportType: SYSTEM_GENERATED,
        status: isClear ? undefined : systemFilterobject.status ? [systemFilterobject.status] : undefined,
        fromDate: isClear ? undefined : (systemFilterobject.fromDate || undefined),
        toDate: isClear ? undefined : (systemFilterobject.toDate || undefined),
        limit: '25',
        offset: offset
      }
    }
    if (type == 'UserGenerated') {
      if (!silent) setTotalRowCountUG(0);
      if (!silent && offset == '1') {
        setPageNumberUG(0)
      }
    } else {
      if (!silent) setTotalRowCountSG(0);
      if (!silent && offset == '1') {
        setPageNumberSG(0)
      }
    }

    let gridresponse = await getReportGridData(request);
    if (gridresponse?.status == 200) {
      console.log("Grid Response ", gridresponse.data);
      if (gridresponse?.data) {
        let gridData = gridresponse.data.result;
        const datearray = gridData.filter((obj: any) => {
          return (new Date(obj.date).getMonth() + '/' + new Date(obj.date).getDate() + '/' + new Date(obj.date).getFullYear());
        })
        datearray.sort((a: any, b: any) => a.dateandTime > b.dateandTime ? -1 : 1)
        if (type == 'UserGenerated') {
          setTotalRowCountUG(gridresponse.data.totalCount)
          setPageCountUG(Math.ceil(gridresponse.data.totalCount / 25));
          setUserGenGridData(datearray)
        } else if (type == 'SystemGenerated') {
          setTotalRowCountSG(gridresponse.data.totalCount)
          setPageCountSG(Math.ceil(gridresponse.data.totalCount / 25));
          setSystemGenGridData(datearray)
        }
      } else if ((!gridresponse?.data.length || gridresponse?.status == 204) && !silent) {
        setnocontent(true);
        if (type == 'UserGenerated') {
          setUserGenGridData([])
        } else if (type == 'SystemGenerated') {
          setSystemGenGridData([])
        }
      }
      else {
        if (type == 'UserGenerated') {
          setUserGenGridData([])
        } else if (type == 'SystemGenerated') {
          setSystemGenGridData([])
        }
        setloader('');
      }
    }
    else {
      setloader('');
      if (!silent) setpopupop('GridError');
    }
    setloader('');
  }

  const isReportsDialogOpen = popupop !== '';
    const onReportsSilentRefresh = useCallback(() => {
    if (activetab == 1) {
      gridloadapi(pageNumberUG > 0 ? String(pageNumberUG + 1) : '1', 'UserGenerated', false, true);
    } else if (activetab == 2) {
      gridloadapi(pageNumberSG > 0 ? String(pageNumberSG + 1) : '1', 'SystemGenerated', false, true);
    }
  }, [activetab, pageNumberUG, pageNumberSG, filterobject, systemFilterobject]);
  useAutoRefresh({ intervalMs: refreshIntervalMs, idleTimeoutMs, isDialogOpen: isReportsDialogOpen, onRefresh: onReportsSilentRefresh });

  const genRepLoad = async (isClear?: boolean) => {
    if (activetab == 1 && filterAppliedUG) {
      await gridloadapi('1', 'UserGenerated', isClear)
    } else if (activetab == 2 && filterAppliedSG) {
      gridloadapi('1', 'SystemGenerated', isClear)
    }
  };

  useEffect(() => {
    gridbind ? genRepLoad() : '';
  }, [gridbind]);

  const optionsfill = (zoneDD: any) => {
    const zonvalary: any = zoneDD.map((b: any) => {
      return b.zone;
    });
    const sortedzonenum = zonvalary.sort(function (a: any, b: any) {
      return a - b;
    });
    setzonevalue(sortedzonenum);
  };

  const buildGridHeader = (dataColumns: any, dataValues: any) => {
    return (
      <>
        {dataColumns.map((value: any, index: any) => {
          return value.columnTitle == 'Action' ? (
            <RACTableCell
              key={index}
              className={`${pricing.headingCss} ${classes.textCenter}`}
            >
              Action
            </RACTableCell>
          ) : (
            <RACTableCell key={index} className={`${pricing.headingCss}`}>
              {value.IsSortable ? (
                <a
                  style={{
                    color: 'black',
                    textDecoration: 'none',
                    cursor: 'pointer',
                  }}
                  id={value.columnId}
                  onClick={() =>
                    SortOperation(
                      value.columnId,
                      index,
                      dataColumns,
                      dataValues,
                      activetab == 1 ? 'UserGenerated' : 'SystemGenerated'
                    )
                  }
                >
                  {value.columnTitle + '  '}
                  {value.IsSorted === true ? (
                    value.sortOrder == sortDirection.DESC ? (
                      <SortIconUp className={classes.ml2} />
                    ) : (
                      <SortIcon className={classes.ml2} />
                    )
                  ) : null}
                </a>
              ) : (
                <a
                  style={{
                    color: 'black',
                    textDecoration: 'none',
                  }}
                  id={value.columnId}
                >
                  {value.columnTitle + '  '}
                </a>
              )}
            </RACTableCell>
          );
        })}
      </>
    );
  };

  const SortOperation = (
    columnId: string,
    index: any,
    datacolumn: any,
    dataValues: any,
    type: string
  ) => {
    /* eslint-disable no-debugger */
    // debugger
    try {
      const sortedData: any =
        datacolumn[index].sortOrder == sortDirection.DESC
          ? dataValues.sort((a: any, b: any) =>
            b[columnId] < a[columnId] ? -1 : 1
          )
          : dataValues.sort((a: any, b: any) =>
            a[columnId] < b[columnId] ? -1 : 1
          );
      const reorderColumns: columns[] = datacolumn;
      reorderColumns[index].sortOrder =
        reorderColumns[index].sortOrder == sortDirection.ASC
          ? sortDirection.DESC
          : sortDirection.ASC;
      reorderColumns.map((value: any, index1: any) => {
        reorderColumns[index1].IsSorted = index == index1 ? true : false;
      });

      if (type == 'UserGenerated') {
        setUserGenGridData([...sortedData]);
        setheaderdata([...reorderColumns]);
      } else {
        setSystemGenGridData([...sortedData]);
        setSysGenHeaderdata([...reorderColumns])
      }
    } catch (ex) {
      console.log(ex);
    }
  };
  //new Updated Fixed the comma issue
  const splittingZoneArr = (obj: any) => {
    if (obj.length <= 1) {
      return obj[0];
    } else {
      if (obj.length == 2) {
        return obj[0] + ',' + ' ' + obj[1];
      } else if (obj.length == 3) {
        return obj[0] + ',' + ' ' + obj[1] + ',' + ' ' + obj[2];
      } else if (obj.length > 3) {
        return obj[0] + ',' + ' ' + obj[1] + ',' + ' ' + obj[2] + '...';
      }
    }
  };

  const splitcomma = (obj: any) => {
    const lastzonenum = obj.slice(3, obj.length);
    const lastzonenumsort = lastzonenum.sort(function (a: any, b: any) {
      return a - b;
    });
    return lastzonenumsort.map((el: any, index: any) => {
      if (lastzonenumsort.length == 0 || index == lastzonenumsort.length - 1) {
        return el;
      } else {
        return el + ''; // " return el + ',' + ''; " for Tooltip package
      }
    });
  };

  //Download the Xl Files
  const getReportXlFiles = async (dockey: any) => {
    const key = {
      key: dockey,
      type: 'GET',
    };
    const ReportResposne = await getXlFile(key);
    const link = ReportResposne.data.generatedUrl;
    if (ReportResposne.status == 200 && ReportResposne.status != undefined) {
      const element = document.createElement('a');
      element.setAttribute('href', `${link}`);
      element.setAttribute('style', 'display:none');
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } else if (ReportResposne.status == 400) {
      setpopupop('ErrorpopupDoc400');
    } else {
      setpopupop('Errorpopup');
    }
    setDownloadloader('-1');
  };

  const renderTableContent: any = (renderData: any, type: string) => {
    return renderData.map((obj: any, index: any) => {
      return (
        <React.Fragment key={index}>
          <RACTableRow className={classes.bgTransparent}>
            {type == 'UserGenerated' ? <RACTableCell
              title={obj.zone.length > 3 ? splitcomma(obj.zone) : null}
              className={`${pricing.p36} ${pricing.zonewidth}`}
            >
              <Typography
                variant="caption"
                className={`${classes.textGrey} ${classes.fs7} ${classes.fontSemiBold}`}
              >
                {' '}
                {obj.zone.length > 0 && obj.zone != ''
                  ? splittingZoneArr(
                    obj.zone.sort(function (a: any, b: any) {
                      return a - b;
                    })
                  )
                  : '-'}{' '}
              </Typography>
            </RACTableCell> : null}
            <RACTableCell className={`${pricing.p36} ${pricing.typewidth}`}>
              <Typography
                variant="caption"
                className={`${classes.textGrey} ${classes.fs7} ${classes.fontSemiBold}`}
              >
                {' '}
                {obj.type}{' '}
              </Typography>
            </RACTableCell>
            <RACTableCell className={`${pricing.p36} ${pricing.datewidth}`}>
              <Typography
                variant="caption"
                className={`${classes.textGrey} ${classes.fs7} ${classes.fontSemiBold}`}
              >
                {' '}
                {moment(new Date(obj.date)).format(monthDateFormat) +
                  ' ' +
                  moment(new Date(obj.date)).format('h:mm A')}{' '}
              </Typography>
            </RACTableCell>
            <RACTableCell className={`${pricing.p36} ${pricing.statuswidth}`}>
              <Typography
                variant="caption"
                className={`${classes.textGrey} ${classes.fs7} ${classes.fontSemiBold}`}
              >
                {' '}
                {obj.status}
              </Typography>
            </RACTableCell>
            <RACTableCell
              title={
                Downloadloader != obj.documentKey && Downloadloader != '-1'
                  ? 'Please wait while downloading...'
                  : undefined
              }
              className={`${pricing.actionwidth} ${pricing.textCenter}`}
            >
              {obj.status === 'Pending' || obj.status === 'Failed' ? (
                <RACButton
                  disabled
                  color="primary"
                  className={classes.bgLightBlue}
                >
                  Download
                </RACButton>
              ) : obj.status === 'Completed' ? (
                Downloadloader != obj.documentKey ? (
                  Downloadloader != '-1' ? (
                    <RACButton
                      disabled
                      color="primary"
                      className={classes.bgLightBlue}
                      id={index}
                    >
                      Download
                    </RACButton>
                  ) : (
                    <RACButton
                      color="primary"
                      className={classes.bgLightBlue}
                      id={index}
                      onClick={() => {
                        getReportXlFiles(obj.documentKey);
                        setDownloadloader(obj.documentKey);
                      }}
                    >
                      Download
                    </RACButton>
                  )
                ) : (
                  <CircularProgress
                    style={{ width: '30px', height: '30px' }}
                  ></CircularProgress>
                )
              ) : (
                <RACTableCell
                  className={`${pricing.p36} ${pricing.actionwidth} ${pricing.textCenter}`}
                >
                  {' '}
                  -{' '}
                </RACTableCell>
              )}
            </RACTableCell>
          </RACTableRow>
        </React.Fragment>
      );
    });
  };

  const handleOnChangeStatusCheck = (e: any) => {
    //eslint-disable-next-line no-debugger
    //debugger
    if (activetab == 1) {
      setfilterobject({ ...filterobject, status: e.target.value });
    } else {
      setSystemFilterobject({ ...systemFilterobject, status: e.target.value });
    }
  };

  const dropDwnStatusOptions = () => {
    return [
      { label: 'Select', value: '' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Failed', value: 'Failed' },
      { label: 'Pending', value: 'Pending' },
    ];
  };

  const handleOnChangeFDate = (inputTxt: any) => {
    const fromDate = inputTxt;
    const toDate = activetab == 1 ? userGenToDate : sysGenToDate;
    if (activetab == 1) {
      setfilterobject({ ...filterobject, fromDate: fromDate });
    } else {
      setSystemFilterobject({ ...systemFilterobject, fromDate: fromDate });
    }
    const startDate = moment(fromDate, "YYYY-MM-DD");
    if (startDate && currentDate) {
      if (startDate?.isAfter(currentDate)) {
        activetab == 1 ? seterrormsg('Invalid From Date') : seterrormsgSG('Invalid From Date')
      } else if (startDate && toDate && startDate?.isAfter(toDate)) {
        activetab == 1 ? seterrormsg('From date should be Lesser than To date') : seterrormsgSG('From date should be Lesser than To date')
      } else {
        activetab == 1 ? seterrormsg('') : seterrormsg('')
      }
    }
    if (startDate && !toDate) {
      if (activetab == 1) {
        setfilterobject({ ...filterobject, toDate: moment(new Date()).format("YYYY-MM-DD"), fromDate: fromDate });
      } else {
        setSystemFilterobject({ ...systemFilterobject, toDate: moment(new Date()).format("YYYY-MM-DD"), fromDate: fromDate });
      }
    }
  };

  const handleOnChangeTDate = (inputTxt: any) => {
    const fromDate = activetab == 1 ? userGenFromDate : sysGenFromDate;;
    const toDate = inputTxt;
    if (activetab == 1) {
      setfilterobject({ ...filterobject, toDate: toDate });
    } else {
      setSystemFilterobject({ ...systemFilterobject, toDate: toDate });
    }
    const endDate = moment(toDate, "YYYY-MM-DD");
    if (endDate && currentDate) {
      if (endDate?.isAfter(currentDate)) {
        activetab == 1 ? seterrormsg('Invalid To Date') : seterrormsgSG('Invalid To Date')
      } else if (endDate && fromDate && endDate?.isBefore(fromDate)) {
        activetab == 1 ? seterrormsg('To date should be greater than from date') : seterrormsgSG('To date should be greater than from date')
      } else {
        activetab == 1 ? seterrormsg('') : seterrormsgSG('')
      }
    }
  };

  const ApplyBtnDisable = () => {
    if ((activetab == 1 && (filterobject.status || filterobject.fromDate || filterobject.toDate) &&
      errormsg === '' && errormsgTo === '') || (activetab == 2 && (systemFilterobject.status || systemFilterobject.fromDate || systemFilterobject.toDate) && errormsg === '' && errormsgTo === '')) {
      return false;
    } else {
      return true;
    }
  };

  const clearButton = () => {
    setpopupop('');
    if (activetab == 1) {
      seterrormsg('');
      seterrormsgTo('');
      setFilterAppliedUG(false);
      setfilterobject({ ...filterobject, status: '', fromDate: '', toDate: '' });
    } else {
      seterrormsgSG('');
      seterrormsgToSG('');
      setFilterAppliedSG(false);
      setSystemFilterobject({ ...systemFilterobject, status: '', fromDate: '', toDate: '' });
    }
    genRepLoad(true);
  };

  const Clearbtndisable = () => {
    if ((activetab == 1 && filterobject.status == '' && filterobject.fromDate == '' && filterobject.toDate == '') ||
      (activetab == 2 && systemFilterobject.status == '' && systemFilterobject.fromDate == '' && systemFilterobject.toDate == '')) {
      return true;
    } else {
      return false;
    }
  };

  const zonedata = () => {
    return zonevalue.map((elem: any) => {
      return {
        label: elem,
        value: elem,
      };
    });
  };

  const genReportbtnStatus = () => {
    if (genType == '' || genType === '0') {
      return true;
    }
    // eslint-disable-next-line sonarjs/no-identical-expressions
    else if (
      (genType === 'Pricing' && genZone.length === 0) ||
      (genType === 'StoreZone' && genZone.length === 0) ||
      (genType === 'Autoterm' && genZone.length === 0) ||
      (genType === 'Package' && genZone.length === 0)
    ) {
      return true;
    } else {
      return false;
    }
  };
  // eslint-disable-next-line sonarjs/no-identical-functions
  const zoneDDstatus = () => {
    if (
      genType == '' ||
      genType === 'Unassigned' ||
      genType === 'Zone' ||
      genType === '0' ||
      genType === 'OverallMissingPrice' ||
      genType === 'Cost Based Pricing'
    ) {
      return true;
    }
  };

  const genReportBtnClick = async () => {
    setgenZone([]);
    setgenType('0');
    setpopupop('');
    const zoneReqAry: any = [];
    let req: any;

    if (genZone.length != 0 || genType != '') {
      genZone.map((obj: any) => {
        zoneReqAry.push(obj.value);
      });
      if (genType == 'Zone' || genType == 'Unassigned') {
        req = {
          type: genType,
          //companyCode: companyCode
        };
      } else {
        const zonelength = zonevalue.length;
        if (zonelength == 1 && zoneReqAry.length == 1) {
          req = {
            zone: zoneReqAry,
            type: genType,
            //companyCode: companyCode
          };
        } else {
          req = {
            zone: zoneReqAry.length === zonelength ? ['ALL'] : zoneReqAry,
            type: genType,
            //companyCode: companyCode
          };
        }
      }
      setloader('masterLoader');
      //setpopupop('gridloader');
      const genRepRes = await generateReport(req);
      if (
        genRepRes.status == 200 &&
        genRepRes.status != undefined &&
        genRepRes.status != '' &&
        genRepRes.status != null
      ) {
        setpopupop('genreport');
      } else if (genType == 'OverallMissingPrice' && genRepRes.status == 400) {
        setpopupop('Generate400')
      } else {
        setpopupop('Errorpopup');
      }
      setloader('');
    }
  };

  const typeSelectDD = () => {
    const selectOptions = [
      { label: 'Select', value: '0' },
      { label: 'Package', value: 'Package' },
      { label: 'Pricing', value: 'Pricing' },
      { label: 'Overall Missing Price', value: 'OverallMissingPrice' },
      { label: 'Store-Zone', value: 'StoreZone' },
      { label: 'Un-Assigned Store', value: 'Unassigned' },
      { label: 'Zone', value: 'Zone' },
    ];
    if (hasAccess.autoTermPricingViewAccess) {
      selectOptions.push({ label: 'Autoterm', value: 'Autoterm' });
    }
    if (showSecondaryCriteria) {
      selectOptions.push({ label: 'Secondary Criteria', value: 'Secondary Criteria' });
    }
    if (hasAccess.pricingReportEditAccess && hasAccess.costBasedPricingViewAccess) {
      selectOptions.push({ label: 'Cost Based Pricing', value: 'Cost Based Pricing' });
    }
    if (hasAccess.pricingReportEditAccess && hasAccess.zoneBasedPricingViewAccess) {
      selectOptions.push({ label: 'Zone Based Pricing', value: 'Zone Based Pricing' });
    }
    if (hasAccess.pricingReportEditAccess && (hasAccess.costBasedPricingViewAccess || hasAccess.zoneBasedPricingViewAccess)) {
      selectOptions.push({ label: 'Auto Generated Price', value: 'Auto Generated Price' });
    }
    return selectOptions
  };

  const getAllOptions: any = () => zonedata().map((option: any) => option.value);
  const getCostBasedOptions: any = () => zonedata().filter((option: any) => option.value == '2000');

  const generateReportPopup = () => {
    return (
      <>
        <Grid className={`${classes.mx2} ${pricing.multioverflow}`}>
          <Grid container spacing={2} className={pricing.multioverflow}>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              className={pricing.pbcustom}
            >
              <RACSelect
                inputLabel="Type"
                defaultValue={genType !== '' ? genType : '0'}
                onChange={(e: any) => {
                  setgenZone([]);
                  setgenType(e.target.value);
                  if (e.target.value == 'OverallMissingPrice') {
                    setgenZone(getAllOptions());
                  } else if (e.target.value == 'Cost Based Pricing') {
                    setgenZone(getCostBasedOptions());
                  }
                  if (e.target.value == 'Pricing' || e.target.value == 'Secondary Criteria') {
                    setSelectAll(false)
                  } else {
                    setSelectAll(true)
                  }
                }}
                options={typeSelectDD()}
                inputLabelClassName={`${pricing.Bottom}`}
              ></RACSelect>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={12}
              lg={12}
              className={pricing.pbcustom1}
            >
              <Typography className="racstrap-tablecell-BgColor">
                Zone
              </Typography>
              <MultiSelect
                options={zonedata()}
                value={genZone}
                className={`${pricing.demo} ${pricing.customMultiselect} ${pricing.Top}`}
                onChange={(e: any) => {
                  setgenZone(e);
                }}
                labelledBy={'Select'}
                hasSelectAll={selectAll}
                disabled={zoneDDstatus()}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className={` ${classes.m2} ${classes.p2} ${classes.componentRight} ${pricing.genbtn}`}
            >
              <RACButton
                variant="outlined"
                color="default"
                className={classes.mr2}
                onClick={() => {
                  setgenZone([]);
                  setgenType('0');
                  setpopupop('');
                }}
              >
                Cancel
              </RACButton>
              <RACButton
                variant="contained"
                color="primary"
                disabled={genReportbtnStatus()}
                onClick={() => genReportBtnClick()}
              >
                Generate{' '}
              </RACButton>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };

  const reportCreatedPopup = () => {
    return (
      <Grid>
        <Grid>
          <SuccesIcon className={`${pricing.successicon}`}></SuccesIcon>
        </Grid>
        <Grid>
          <Typography className={`${pricing.genpop}`}>
            Your report is being generated.
          </Typography>
          <RACButton
            className={`${pricing.genpopupbtn}`}
            variant="contained"
            color="primary"
            onClick={async () => {
              setpopupop('');
              await Promise.all([gridloadapi('1', 'UserGenerated'), gridloadapi('1', 'SystemGenerated')]);
            }}
          >
            OK
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const ErrorPopup = () => {
    return (
      <Grid className={pricing.textSpaceNorecords}>
        <Grid className={pricing.gridtextcenterNorecords}>
          <SomethingWrong className={pricing.racErrorIcon} />
        </Grid>
        {popupop == 'ErrorpopupDoc400' ? (
          <Grid className={`${pricing.textcenterImage} ${classes.fontBold}`}>
            File does not exist !
          </Grid>
        ) : popupop == 'Errorpopup' ? (
          <Grid className={`${pricing.textcenterImage} ${classes.fontBold}`}>
            Something Went Wrong !
          </Grid>
        ) : popupop == 'Generate400' ? (
          <Grid className={`${pricing.textcenterImage} ${classes.fontBold}`}>
            Please wait while the previous missing report is being generated!
          </Grid>
        ) : null}
        <Grid>
          <RACButton
            className={`${pricing.gridgenpopupbtn}`}
            variant="contained"
            color="primary"
            onClick={() => {
              setpopupop('');
            }}
          >
            OK
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const GridErrorPopup = () => {
    return (
      <Grid className={pricing.textSpaceNorecords}>
        <Grid className={pricing.gridtextcenterNorecords}>
          <SomethingWrong className={pricing.racErrorIcon} />
        </Grid>
        <Grid className={`${pricing.textcenterImage} ${classes.fontBold}`}>
          Something Went Wrong !
        </Grid>
        <Grid>
          <RACButton
            className={`${pricing.gridgenpopupbtn}`}
            variant="contained"
            color="primary"
            onClick={() => {
              window.location.reload();
              setpopupop('');
            }}
          >
            OK
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const rendernorecordsheaderUG = () => {
    return (
      <React.Fragment>
        <RACTableCell className={`${pricing.p36}${pricing.zonewidth}`}>
          Zone
        </RACTableCell>
        <RACTableCell className={`${pricing.p36}${pricing.typewidth}`}>
          Type
        </RACTableCell>
        <RACTableCell className={`${pricing.p36}${pricing.datewidth}`}>
          Date & Time
        </RACTableCell>
        <RACTableCell className={`${pricing.p36}${pricing.statuswidth}`}>
          Status
        </RACTableCell>
        <RACTableCell
          className={`${pricing.p36} ${classes.textCenter} ${pricing.actionwidth}`}
        >
          {' '}
          Action
        </RACTableCell>
      </React.Fragment>
    );
  };
  const rendernorecordsheaderSG = () => {
    return (
      <React.Fragment>
        <RACTableCell className={`${pricing.p36}${pricing.typewidth}`}>
          Type
        </RACTableCell>
        <RACTableCell className={`${pricing.p36}${pricing.datewidth}`}>
          Date & Time
        </RACTableCell>
        <RACTableCell className={`${pricing.p36}${pricing.statuswidth}`}>
          Status
        </RACTableCell>
        <RACTableCell
          className={`${pricing.p36} ${classes.textCenter} ${pricing.actionwidth}`}
        >
          {' '}
          Action
        </RACTableCell>
      </React.Fragment>
    );
  };

  const handlePageClickUG = (event: any) => {
    scrollToTop();
    setPageNumberUG(event.selected);
    gridloadapi((event.selected + 1).toString(), 'UserGenerated');
  }
  const handlePageClickSG = (event: any) => {
    scrollToTop();
    setPageNumberSG(event.selected);
    gridloadapi((event.selected + 1).toString(), 'SystemGenerated');
  }

  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollToTop = () => {
    if (containerRef.current) {
      const element = containerRef.current;
      const clientWidth = element.getBoundingClientRect().height;
      const negCal = clientWidth * 2;
      const negVal = clientWidth - negCal;
      window.scrollBy(0, negVal);
    }
  };

  const openFilterpop = () => {
    // To disable the future dates in  RACDate Pickers
    const dt = new Date();
    const time = dt.toLocaleString('en-US', { timeZone: timeZoneChicago });
    const current = time.split(',')[0];
    const mindt = moment().subtract(110, 'years').format(yearDateFormat);
    const maxdt = moment(current).format(yearDateFormat);
    return (
      <Card className={`${classes.positionAbsolute} ${classes.filterDropDown}`}>
        <CardContent>
          <Grid className={`${classes.componentSpaceBetween} ${classes.mb2}`}>
            <Typography variant="h5">Advanced Filter</Typography>
            <FilterClose
              onClick={() => {
                setpopupop('');
              }}
            ></FilterClose>
          </Grid>
          <Grid container spacing={4} className={classes.mb2}>
            <Grid item xs={12} sm={4} md={4} lg={6}>
              <RACSelect
                inputLabel="Status"
                onChange={(e) => handleOnChangeStatusCheck(e)}
                defaultValue={activetab == 1 ? filterobject.status : systemFilterobject.status}
                options={dropDwnStatusOptions()}
              ></RACSelect>
            </Grid>
          </Grid>
          <Grid className={`${classes.mb2}`}>
            <Typography variant="h5">Date Range</Typography>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <RACDatePicker
                label="From"
                onChange={(e: any) => handleOnChangeFDate(e)}
                inputProps={{
                  min: mindt,
                  max: maxdt,
                  onKeyDown: (e: any) => e.preventDefault()
                }}
                value={activetab == 1 ? filterobject.fromDate : systemFilterobject.fromDate}
              ></RACDatePicker>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <RACDatePicker
                label="To"
                inputProps={{
                  min: mindt,
                  max: maxdt,
                  onKeyDown: (e: any) => e.preventDefault()
                }}
                value={activetab == 1 ? filterobject.toDate : systemFilterobject.toDate}
                onChange={(e: any) => handleOnChangeTDate(e)}
              ></RACDatePicker>
            </Grid>
          </Grid>
          <Grid className={pricing.validerroralign}>
            <span style={{ fontFamily: fontOpens, color: 'red' }}>
              {activetab == 1 ? errormsg : errormsgSG}
            </span>
          </Grid>
          <Grid className={pricing.validerroralign}>
            <span style={{ fontFamily: fontOpens, color: 'red' }}>
              {activetab == 1 ? errormsgTo : errormsgToSG}
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={` ${classes.mt4}  ${classes.componentRight}`}
          >
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.mr2}
              disabled={Clearbtndisable()}
              onClick={() => clearButton()}
            >
              Clear
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              className={classes.mr2}
              disabled={ApplyBtnDisable()}
              onClick={() => {
                setpopupop('');
                activetab == 1 ? setFilterAppliedUG(true) : setFilterAppliedSG(true)
                gridloadapi('1', activetab == 1 ? 'UserGenerated' : 'SystemGenerated', false)
              }}
            >
              Apply
            </RACButton>
          </Grid>
        </CardContent>
      </Card>
    );
  };

  return (
    <>
      <Grid container ref={containerRef}>
        <Grid item md={12}>
          {loader == 'masterLoader' ? (
            <Grid className={pricing.masterLoader}>
              <Grid className={pricing.Loader}>
                <CircularProgress />
              </Grid>
            </Grid>
          ) : null}

          <Grid container className={classes.gridLeft} style={{ padding: '10px 10px 5px 10px' }}>
            <Grid item style={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={`${classes.textLeft} ${classes.ml5px}`} variant="h5">Reports</Typography>
              <RACInfoIcon
                infoTitle="This page enables the Pricing Department to generate a report 
                and download the generated report to view in excel format."
                placement="right"
                classes={{
                  tooltip: pricing.tooltip,
                  arrow: pricing.Tooltiparrow,
                }}
                iconClassname={pricing.infocss}
              ></RACInfoIcon>
            </Grid>
            <Grid className={classes.floatRight}><MissingPrice /></Grid>
          </Grid>

          <Card
            className={`${classes.m2} ${classes.racCard} ${classes.overFlowVisible} ${classes.mbFooterSpacing}`}
          >
            <CardContent>
              <Grid container md={12} style={{ alignItems: 'center', justifyContent: 'space-between', padding: '10px' }}>
                <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h5" style={{ float: 'left' }}
                    className={`${classes.tab} ${activetab === 1 ? classes.activeTab : classes.inactiveTab}`}
                    onClick={() => {
                      setActivetab(1);
                      setpopupop('')
                    }}>User Generated</Typography>
                  <Typography variant="h5" style={{ float: 'left' }}
                    className={`${classes.tab} ${activetab === 2 ? classes.activeTab : classes.inactiveTab}`}
                    onClick={() => {
                      setpopupop('')
                      setActivetab(2);
                    }}>System Generated</Typography>
                </Grid>
                <Grid item>
                  <RACButton
                    variant="outlined"
                    color="primary"
                    size="small"
                    id="filterIcon"
                    className={`${classes.mr2} ${classes.filterBtn}`}
                    onClick={() => {
                      // setpopupop('filterpopupon');
                      popupop == ''
                        ? setpopupop('filterpopupon')
                        : setpopupop('');
                    }}
                  >
                    <RacFilter></RacFilter>
                  </RACButton>
                  {popupop == 'filterpopupon' ? openFilterpop() : null}
                </Grid>
              </Grid>
              {loader == 'gridloader' ? (
                <Grid className={pricing.textSpaceNorecords}>
                  <CircularProgress />
                </Grid>
              ) : activetab == 1 && (userGenGridData.length > 0) ? (
                <RACTable
                  renderTableHead={() => buildGridHeader(headerdata, userGenGridData)}
                  renderTableContent={() => renderTableContent(userGenGridData, 'UserGenerated')}
                />
              ) : activetab == 2 && (systemGenGridData.length > 0) ? (
                <RACTable
                  renderTableHead={() => buildGridHeader(sysGenHeaderdata, systemGenGridData)}
                  renderTableContent={() => renderTableContent(systemGenGridData, 'SystemGenerated')}
                />
              ) : (loader != 'masterLoader' && popupop != 'GridError') ||
                nocontent == true ? (
                <Grid>
                  <RACTable renderTableHead={activetab == 1 ? rendernorecordsheaderUG : rendernorecordsheaderSG} />
                  <Grid className={pricing.textSpaceNorecords}>
                    <Grid className={pricing.textcenterNorecords}>
                      <NorecordsIcon className={pricing.racErrorIcon} />
                    </Grid>
                    <Grid className={pricing.textcenterImage}>
                      No Records Found !
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}
              {popupop != 'GridError' &&
                activetab == 1 && userGenGridData?.length > 0 ? (
                <Grid className={`${classes.mb1} ${classes.textRight}`}>
                  <Grid className={`${pricing.totrec}`}>
                    <Typography># of Records: {pageNumberUG == 0
                      ? totalRowCountUG < 25 ? totalRowCountUG : 25 * 1
                      : (pageNumberUG + 1) == pageCountUG
                        ? totalRowCountUG
                        : (pageNumberUG + 1) * 25}
                      /{totalRowCountUG}</Typography>
                  </Grid>
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={(num) => handlePageClickUG(num)}
                    pageCount={pageCountUG}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={0}
                    previousLabel="<"
                    breakLabel=""
                    pageClassName={pricing.pagination}
                    pageLinkClassName={pricing.pagelink}
                    previousLinkClassName={
                      pageNumberUG === 0
                        ? pricing.paginationprevnextdisable
                        : pricing.paginationprevnext
                    }
                    nextLinkClassName={
                      pageNumberUG === pageCountUG - 1
                        ? pricing.paginationprevnextdisable
                        : pricing.paginationprevnext
                    }
                    breakClassName={pricing.pagination}
                    breakLinkClassName={pricing.pagination}
                    containerClassName={pricing.pagination}
                    activeClassName={pricing.pageactive}
                    forcePage={pageNumberUG}
                  />
                </Grid>
              ) : activetab == 2 && systemGenGridData?.length > 0 ? (
                <Grid className={`${classes.mb1} ${classes.textRight}`}>
                  <Grid className={`${pricing.totrec}`}>
                    <Typography># of Records: {pageNumberSG == 0
                      ? totalRowCountSG < 25 ? totalRowCountSG : 25 * 1
                      : (pageNumberSG + 1) == pageCountSG
                        ? totalRowCountSG
                        : (pageNumberSG + 1) * 25}
                      /{totalRowCountSG}</Typography>
                  </Grid>
                  <ReactPaginate
                    nextLabel=">"
                    onPageChange={(num) => handlePageClickSG(num)}
                    pageCount={pageCountSG}
                    pageRangeDisplayed={2}
                    marginPagesDisplayed={0}
                    previousLabel="<"
                    breakLabel=""
                    pageClassName={pricing.pagination}
                    pageLinkClassName={pricing.pagelink}
                    previousLinkClassName={
                      pageNumberSG === 0
                        ? pricing.paginationprevnextdisable
                        : pricing.paginationprevnext
                    }
                    nextLinkClassName={
                      pageNumberSG === pageCountSG - 1
                        ? pricing.paginationprevnextdisable
                        : pricing.paginationprevnext
                    }
                    breakClassName={pricing.pagination}
                    breakLinkClassName={pricing.pagination}
                    containerClassName={pricing.pagination}
                    activeClassName={pricing.pageactive}
                    forcePage={pageNumberSG}
                  />
                </Grid>) : null}
            </CardContent>
          </Card>
        </Grid>
      </Grid >
      <Grid container className={classes.fixedFooter}>
        <Grid>
          <RACButton
            variant="outlined"
            onClick={() => history.push('/dashboard')}
            color="primary"
            className={`${classes.borderNone} ${classes.textBlack}`}
          >
            Cancel
          </RACButton>
        </Grid>
        <Grid>
          <RACButton
            variant="contained"
            color="primary"
            onClick={() => setpopupop('generatepopup')}
          >
            Generate New Report
          </RACButton>
        </Grid>
      </Grid>

      <RACModalCard
        isOpen={popupop == 'generatepopup' ? true : false}
        maxWidth="sm"
        closeIcon={true}
        borderRadius="20px"
        onClose={() => setpopupop('')}
        // eslint-disable-next-line react/no-children-prop
        children={generateReportPopup()}
        title="Generate New Report"
        className={pricing.demopopup}
      />
      <RACModalCard
        isOpen={popupop === 'genreport' ? true : false}
        closeIcon={true}
        maxWidth="xs"
        onClose={async () => {
          setpopupop('');
          await Promise.all([gridloadapi('1', 'UserGenerated'), gridloadapi('1', 'SystemGenerated')]);
        }}
        // eslint-disable-next-line react/no-children-prop
        children={reportCreatedPopup()}
        borderRadius={borRadius}
      />
      <RACModalCard
        isOpen={
          popupop === 'Errorpopup' || popupop == 'ErrorpopupDoc400' || popupop == 'Generate400'
            ? true
            : false
        }
        closeIcon={true}
        maxWidth="xs"
        onClose={() => setpopupop('')}
        // eslint-disable-next-line react/no-children-prop
        children={ErrorPopup()}
        borderRadius={borRadius}
      />
      <RACModalCard
        isOpen={popupop === 'GridError' ? true : false}
        maxWidth="xs"
        // eslint-disable-next-line react/no-children-prop
        children={GridErrorPopup()}
        title="Pricing Report"
        borderRadius={borRadius}
      />
    </>
  );
}
